import React, {useEffect, useState} from "react"
import {IconButton} from "@mui/material"
import FadeInAnimation from "../../../FadeInAnimation"
import NavIcon from "../../../NavIcon"
import {Container} from "../../component"
import Gradient from "../../../Gradient"
import touchDevice from "../../../../utils/is-touch-device"
import {getMeganavIconPath} from "../../../../utils/getCdnUrl"
import {ChevronProps} from "../.."

export const Chevron = (props: ChevronProps) => {
    const {isRTL = false, placement, handleClick, show, chevronIconAltText, realm} = props

    const [onClient, setOnClient] = useState(false)
    useEffect(() => {
        setOnClient(true)
    }, [])
    const isTouchDevice = touchDevice()
    const isLeft = placement === "left"
    const rotate = !isLeft

    return (
        <FadeInAnimation show={show} timeout={350}>
            <Container doRotate={rotate}>
                {!isTouchDevice && onClient && (
                    <IconButton
                        disableRipple
                        onClick={handleClick}
                        data-testid={`meganav-primarynav-arrow-${placement}`}
                        tabIndex={-1}
                        size="large"
                    >
                        <NavIcon
                            imageUrl={getMeganavIconPath("chevron-left.svg", realm)}
                            altText={chevronIconAltText}
                            rotationDegrees={isRTL ? 180 : 0}
                        />
                    </IconButton>
                )}
                <Gradient flip={false} isShown={show} isTouchDevice={isTouchDevice} />
            </Container>
        </FadeInAnimation>
    )
}

export default Chevron
